module.exports = __webpack_public_path__ + "img/wechat.51166553.svg";